import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import ElementUI from 'element-ui';
import VueAMap from 'vue-amap'
import 'element-ui/lib/theme-chalk/index.css';

import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload)
Vue.use(VueAMap);
Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.use(ElementUI);

import JsonExcel from 'vue-json-excel'
Vue.component('downloadExcel', JsonExcel)

import VDistpicker from 'v-distpicker'

Vue.component('v-distpicker', VDistpicker)


import tinymce from 'tinymce'
import VueTinymce from '@packy-tang/vue-tinymce'
Vue.prototype.$tinymce = tinymce // 将全局tinymce对象指向给Vue作用域下
Vue.use(VueTinymce)

import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)

import "@/imges/demo/iconfont.css";

VueAMap.initAMapApiLoader({
	// 高德key
	key: 'SqjzMl67AAfLuDejrVHx6kBjllsZsH5x',
	// 插件集合 （插件按需引入）
	plugin: ['AMap.Autocomplete', 'AMap.ToolBar', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView',
		'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor', 'AMap.MarkerClusterer'
	],
	v: '1.4.15', // 我也不知道为什么要写这个，不写项目会报错，而且我随便写的，跟我下载的版本对应不了
	uiVersion: '1.0.11' // ui版本号，也是需要写
})

new Vue({
	el: '#app',
	axios,
	router,
	render: h => h(App),
}).$mount('#app')
